import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import api, { ApiResponse } from "../services/api";
import Cookies from "js-cookie";
import { verifyToken } from "../utils/auth";

interface LoginResponse {
  success: boolean;
  token: string;
  data: {
    id: string;
    email: string;
    name: string;
    restaurantId: string;
    role: string;
  };
}

const Emplogin: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
     const [isTokenValid, setIsTokenValid] = useState<boolean | null>(null);

  useEffect(() => {
    verifyToken(setIsTokenValid).then((isValid) => {
      if (isValid) {
        window.hasVerifiedToken = true;
        navigate("/sales");
      }
    });
  }, [navigate]);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await api.post<LoginResponse>("/new/emplogin", {
        email,
        password,
      },{withCredentials:true}
    );

      if (data.success) {
        Cookies.set("emptoken", data.token);
        toast.success("Login successful!");
         window.hasVerifiedToken = true; 
        navigate("/Sales");
      } else {
        toast.error("Login failed");
      }
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 401) {
          toast.error("Invalid email or password");
        } else if (error.response.status === 400) {
          toast.error(error.response.data?.error || "Invalid request");
        } else if (error.response.data?.error) {
          // e.g. 402: the restaurant's account is suspended/trial-expired
          toast.error(error.response.data.error);
        } else {
          toast.error("Login failed. Please try again.");
        }
      } else if (error.request) {
        toast.error("Network error. Please check your connection.");
      } else {
        toast.error("Login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-md">
        <h1 className="text-center mb-6 text-primary text-2xl font-semibold">
          Sales Login
        </h1>

        <form onSubmit={handleSubmit}>
          <div className="mb-5">
            <label
              htmlFor="email"
              className="block mb-2 text-gray-700 font-medium"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full p-3 border border-gray-300 rounded-md text-base focus:outline-none focus:ring-2 focus:ring-main"
            />
          </div>

          <div className="mb-6">
            <label
              htmlFor="password"
              className="block mb-2 text-gray-700 font-medium"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full p-3 border border-gray-300 rounded-md text-base focus:outline-none focus:ring-2 focus:ring-main"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full p-3 text-white text-lg font-medium rounded-md transition-all duration-100
              ${
                loading
                  ? "bg-main/50 opacity-70 cursor-not-allowed"
                  : "bg-main hover:bg-main/90 hover:shadow-lg transform hover:scale-105"
              }
            `}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Emplogin;
